import { NgModule } from "@angular/core";
import { ThermalApi } from "./thermal-api";
import { ThermalAuth } from "./thermal-auth";
import { ThermalResponses } from "./thermal-responses";
import { PersonsApi } from "./services/persons.api";
import { FaceApi } from "./services/face.api";
import { HTTP } from '@ionic-native/http';
import { AttendanceApi } from "./services/attendance.api";
import { ConfigApi } from "./services/config.api";
@NgModule({
    declarations: [],
    imports: [],
    providers: [
        ThermalApi,
        ThermalAuth,
        ThermalResponses,
        PersonsApi,
        FaceApi,
        HTTP,
        AttendanceApi,
        ConfigApi,
    ]
})
export class ThermalApiModule {
}


// WEBPACK FOOTER //
// ./src/shared/thermal/thermal-api.module.ts